import { useMemo } from 'react';
import { Box } from '@material-ui/core';
import { SInfiniteTable, SText, TableLoader } from '@setvi/shared/components';
import { OrderItemHistory } from '@setvi/shared/services/react-query/query/orders/types';
import { useProducts, UseReorderHistoryProps } from './hooks';
import { orderHistoryColumns } from './hooks/use-products/columns';
import { ContentTitleContainer } from '../product-info';
import { ProductsEmptyState } from '../../components';

export const OrderHistory = (props: UseReorderHistoryProps) => {
  const { products, isLoading } = useProducts(props);

  const content = useMemo(() => {
    if (isLoading) return <TableLoader columns={orderHistoryColumns} />;

    if (!products.length && !isLoading)
      return (
        <Box flex={1} display="flex">
          <ProductsEmptyState title="No Order History" />
        </Box>
      );

    return (
      <Box flex={1} overflow="auto">
        <SInfiniteTable<OrderItemHistory>
          list={products}
          columns={orderHistoryColumns}
          keyGetter={item => item?._id}
        />
      </Box>
    );
  }, [isLoading, products]);

  return (
    <Box
      height="100%"
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}>
      <ContentTitleContainer>
        <SText title="Order History" weight="semibold" />
      </ContentTitleContainer>
      {content}
    </Box>
  );
};
